class JoinTheCommunitySlider {
  constructor(container) {
    this.container = container;
    this.splideInstance = null;
    this.init();
  }

  init() {
    this.handleSplideSlider();
  }

  handleSplideSlider() {
    const videoSlider = this.container;

    if (videoSlider) {
      if (this.splideInstance) {
        this.splideInstance.destroy(true);
      }

      this.splideInstance = new Splide(videoSlider, {
        type: 'slide',
        perPage: 4,
        perMove: 1,
        arrows: false,
        pagination: false,
        gap: '65px',
        focus: 'center',
        breakpoints: {
          992: {
            perPage: 1,
            gap: '17px',
          }
        }
      });

      this.splideInstance.mount();
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const joinTheCommunitySection = document.querySelector('[what-youll-get-slider]');

  if (joinTheCommunitySection) {
    new JoinTheCommunitySlider(joinTheCommunitySection);
  }
});

document.addEventListener('shopify:section:load', (event) => {
  const joinTheCommunitySection = event.target.querySelector('[what-youll-get-slider]');

  if (joinTheCommunitySection) {
    new JoinTheCommunitySlider(joinTheCommunitySection);
  }
});